var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGng(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 175,
    viewBox: "50 68.4 940.7 724",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("text", {
    fill: "#757575",
    fontFamily: "Sans-serif",
    fontSize: 400,
    fontWeight: "bold",
    id: "svg_1",
    stroke: "#000000",
    strokeWidth: 0,
    textAnchor: "middle",
    x: 155,
    xmlSpace: "preserve",
    y: 376.5
  }, "G"), /*#__PURE__*/React.createElement("text", {
    fill: "#7a7a7a",
    fontFamily: "Sans-serif",
    fontSize: 400,
    fontWeight: "bold",
    id: "svg_6",
    stroke: "#000000",
    strokeWidth: 0,
    textAnchor: "middle",
    transform: "matrix(-1 0 0 1 613 205)",
    x: 132.5,
    xmlSpace: "preserve",
    y: 170.5
  }, "G"), /*#__PURE__*/React.createElement("text", {
    fill: "#bcbcbc",
    fontFamily: "Helvetica",
    fontSize: 220,
    fontWeight: "bold",
    id: "svg_3",
    stroke: "#000000",
    strokeWidth: 0,
    textAnchor: "middle",
    transform: "matrix(1 0 0 0.976283 0 10.1411)",
    x: 316,
    xmlSpace: "preserve",
    y: 374.95
  }, "N"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGng);
export default __webpack_public_path__ + "static/media/gng.5992ef0d5c86564e386754b3dd7245b4.svg";
export { ForwardRef as ReactComponent };